export const calculateDateDifference = (bigDate: Date, smallDate: Date): number => {
  return bigDate.getTime() - smallDate.getTime();
};
